import React, { Component } from 'react';
import ActionModal, { ActionModalFooter } from 'common-components/modal/ActionModal';
import { Text } from 'common-components/typography';
import { PrimaryButton, SecondaryButton } from 'common-components/buttons';
import _ from 'lodash';
import { IShiftSlot } from 'interfaces/shift-interfaces';
import { IRootDispatch, IRootState } from 'stores/rematch/root-store';
import { connect } from 'react-redux';
import { Spinner } from '@blueprintjs/core';
import { ISession } from 'interfaces/session-interfaces';

interface IRevokeApprovalModalProps {
  isOpen: boolean;
  shiftSlot: IShiftSlot;
  onClose: any;
  doRevokeShiftApproval: any;
  session: ISession;
}

interface IRevokeApprovalModalState {
  step: number;
  canManuallyClose: boolean;
}

class RevokeApprovalModal extends Component<IRevokeApprovalModalProps, IRevokeApprovalModalState> {
  state = {
    step: 1,
    canManuallyClose: true,
  };

  private _reset = () => this.setState({ step: 1 });

  private _onSave = async () => {
    const { doRevokeShiftApproval } = this.props;

    this.setState({ step: 2, canManuallyClose: false });

    const request = {};
    await doRevokeShiftApproval(request);

    this.setState({ step: 3, canManuallyClose: true });
  };

  private _onClose = () => {
    const { onClose } = this.props;
    this._reset();
    onClose({ targetFlag: 'isRevokeApprovalOpen' });
  };

  render() {
    const { shiftSlot } = this.props;

    if (_.isEmpty(shiftSlot)) {
      return <></>;
    }

    return (
      <ActionModal
        isOpen={this.props.isOpen}
        title="Revoke approval"
        onClose={this._onClose}
        canCloseOutside={this.state.canManuallyClose}
      >
        {this.state.step === 1 && (
          <div>
            <div className="mb-medium line-height-135">
              <Text lineHeight={135}>
                You are about to revoke approval for the selected shift. <br />
                <br />
                Are you sure you want to continue?
              </Text>
            </div>

            <ActionModalFooter align="right">
              <SecondaryButton size="large" className="mr-medium" onClick={this._onClose}>
                Cancel
              </SecondaryButton>
              <PrimaryButton size="large" onClick={this._onSave}>
                Revoke approval
              </PrimaryButton>
            </ActionModalFooter>
          </div>
        )}

        {this.state.step === 2 && (
          <div className="line-height-135 anim-slide-left">
            <div className="flex-column align-center mv-large justify-center">
              <div className="mb-medium">
                <Spinner size={80} />
              </div>
              <div className="text-align-center">
                <Text color="secondary" weight="bold">
                  Revoking approval...
                </Text>
                <br />
                <Text color="secondary">This won't take long.</Text>
              </div>
            </div>
          </div>
        )}

        {this.state.step === 3 && (
          <div className="anim-fade-in-fast">
            <div className="mb-medium line-height-135">
              <Text lineHeight={135}>You have successfully revoked approval for this shift.</Text>
            </div>

            <ActionModalFooter align="right">
              <PrimaryButton size="large" onClick={this._onClose}>
                Close
              </PrimaryButton>
            </ActionModalFooter>
          </div>
        )}
      </ActionModal>
    );
  }
}

const mapState = (state: IRootState) => ({});

const mapDispatch = (dispatch: IRootDispatch) => ({
  doRevokeShiftApproval: dispatch.groupServiceStore.doRevokeShiftApproval,
});

export default connect(mapState, mapDispatch)(RevokeApprovalModal);
